// Validation max lengths
import type { IRadioItem } from "@rhc-shared-components/form-radio-select";
import { EWorkloadType } from "./product";

export const PRODUCT_FEATURES_TITLE_MAXLENGTH = 60;
export const PRODUCT_FEATURES_DESCRIPTION_MAXLENGTH = 1000;
export const PRODUCT_GENERAL_SHORT_DESCRIPTION_MAXLENGTH = 200;
export const PRODUCT_GENERAL_SHORT_DESCRIPTION_MINLENGTH = 50;
export const PRODUCT_GENERAL_LONG_DESCRIPTION_MAXLENGTH = 800;
export const PRODUCT_GENERAL_LONG_DESCRIPTION_MINLENGTH = 100;
export const PRODUCT_GENERAL_LOGO_MAX_UPLOAD_SIZE = 1;
export const PRODUCT_GENERAL_LOGO_SUPPORTED_FILE_TYPES = ["svg", "png", "image/svg+xml", "image/png"];
export const PRODUCT_QUICK_START_MAXLENGTH = 10000;
export const PRODUCT_SEO_SEARCH_ALIAS_VALUE_MAXLENGTH = 50;
export const PRODUCT_SUPPORT_MAXLENGTH = 500;
export const PRODUCT_NAME_MAXLENGTH = 100;
export const PRODUCT_FAQ_QUESTION_MAXLENGTH = 250;
export const PRODUCT_FAQ_ANSWER_MAXLENGTH = 2000;
export const PRODUCT_LINKED_RESOURCES_TITLE_MAXLENGTH = 50;
export const PRODUCT_LINKED_RESOURCES_DESCRIPTION_MAXLENGTH = 100;
export const PRODUCT_LINKED_RESOURCES_URL_MAXLENGTH = 250;

// Validation messages
export const REQUIRED_MESSAGE = "Required";
export const REQUIRED_MAX_CHAR_LENGTH = "Maximum 2048 characters are allowed";
export const REQUIRED_MIN_CHAR_LENGTH = "Minimum 1 character(s) are required";
export const MAXIMUM_10_CONTACTS = "Maximum 10 contacts";
export const VALID_URL = "Should be a valid URL";
export const NO_STARTING_WHITESPACES = "Name can't start with spaces";
export const VALID_EMAIL = "Must be a valid email address";
export const UNIQUE_EMAIL = "Email IDs should be unique";
export const RED_HAT_NAMING_GUIDELINE_ERROR = `This field cannot contain any variant of Red Hat unless it is preceded by 'for'`;

// The radio option value is the workload_type persisted on the product validation.
export const ContainerValidationTypeOptions: IRadioItem[] = [
	{
		name: "Standard Containerized Application",
		value: EWorkloadType.General,
	},
	{
		name: "CNF (Cloud-Native Network Function)",
		value: EWorkloadType.CNF,
	},
	{
		name: "OpenShift Virtualization",
		value: EWorkloadType.Virt,
	},
];

export const StandaloneValidationTypeOptions: IRadioItem[] = [
	{
		name: "Standalone Application",
		value: EWorkloadType.General,
	},
	{
		name: "OpenShift Virtualization",
		value: EWorkloadType.Virt,
	},
];

// Maps a workload_type (radio option value / persisted product validation) to its questionnaire alias.
export const WorkloadTypeQuestionnaireAlias: Record<EWorkloadType, string> = {
	[EWorkloadType.General]: "softwarevalidation",
	[EWorkloadType.CNF]: "cnfvalidation",
	[EWorkloadType.Virt]: "openshiftvirt",
};

export const SUPPORTED_PLATFORMS_MAX_ROWS = 5;

// Regex
export const PHONE_NUMBER_REGEX =
	/^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s.]?[(]?[0-9]{1,3}[)]?([-\s.]?[0-9]{3})([-\s.]?[0-9]{3,4})$/;
export const STARTING_WHITESPACES_REGEX = /^[\w][\w\d\s]*/;
export const UNICODE_URL_REGEX = /^(https?):\/\/(([\p{L}\p{N}-]+\.)*[\p{L}\p{N}-]+\.[\p{L}]{2,})(:\d+)?(\/[^\s]*)?$/u;
export const OPENSHIFT_CONTAINER_FULLNAME_REGEX = /Red Hat OpenShift Container Platform/g;
export const OPENSHIFT_NAME_REGEX = /Red Hat OpenShift/g;
